import { Card } from '@material-ui/core';
import React, { ReactNode, useCallback } from 'react';
import { getUniqueKey } from 'utils/KeyUtils';
import styles from './VimeoEmbed.scss';
const rootClassName = styles.rootClassName;

interface Props {
  id: string;
  autoPlay?: boolean;
  raw?: boolean;
}

export default ({
  id,
  autoPlay,
  raw,
}: Props) => {

  const uniqueId: string = getUniqueKey();

  const getContainer = useCallback((video: ReactNode) => {
    if (raw) {
      return (
        <div
          className={ rootClassName }
        >
          { video }
        </div>
      )
    }
    return (
      <Card
        className={ rootClassName }
      >
        { video }
      </Card>
    )
  }, [raw])

  return getContainer(
    <iframe
      src={`https://player.vimeo.com/video/${id}?color=${styles.primarySicredi.substr(1)}&embed.buttons.like=false&buttons.share=flase&title=0&byline=0&portrait=0`}
      className={ rootClassName + '-embed' }
      frameBorder="0"
      title={uniqueId}
      allowFullScreen
    >
    </iframe>
  )
}